import React from 'react'
import { Switch as ChakraSwitch, Box, FormControl, Text } from "@chakra-ui/react"

const Switch = ({label, ...props}) => {

    return(
        <FormControl>            
            <label>
                <Box my="0.5" display="flex" alignItems="flex-start">                    
                    <ChakraSwitch isFocusable={false} size="sm" colorScheme="brand" {...props} mt="1" mr="3" />
                    <Text m="0" size="sm" color="gray.500">{label}</Text>
                </Box>
            </label>
        </FormControl>
    )
}

export {Switch}